import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { UserFeedbackComponent } from 'app/features/comms/components/user-feedback/user-feedback.component';
import { RiderService } from 'app/services';

@Component({
    selector: 'user-feedback-filter',
    templateUrl: './user-feedback-filter.component.html',
    styleUrls: ['./user-feedback-filter.component.scss'],
    providers: [MessageService]
})
export class UserFeedbackFilterComponent implements OnInit {
    @Input()
    public userFeedbackComponent!: UserFeedbackComponent;

    public riderId: number | null = null;

    public startDate: Date = new Date();
    public endDate: Date = new Date();

    public riders: any;

    constructor(private messageService: MessageService, private riderService: RiderService) { }

    ngOnInit(): void {
        this.getRiders();
    }

    private getRiders() {
        const dto = {};

        this.riderService.getRiders(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                console.log(data);
                this.riders = data.Riders;
            });

    }

    public clickFilter() {
        this.userFeedbackComponent.filter.riderId = this.riderId;
        this.userFeedbackComponent.filter.startDate = this.startDate;
        this.userFeedbackComponent.filter.endDate = this.endDate;
        this.userFeedbackComponent.visibleFeedbackFilter = false;
        this.userFeedbackComponent.getUserFeedbacks(0);
    }
}
